import React from "react";
import {
  BookOpen,
  GitBranch,
  MessageCircle,
  GraduationCap,
} from "lucide-react";

const Expectation = () => {
  const features = [
    {
      icon: <BookOpen className="w-6 h-6 text-primaryColor" />,
      title: "Allocate the time for study",
      desc: "Allocating time for study helps you stay organized and consistent in your learning.Set a specific schedule each day to focus on different subjects or topics.Avoid distractions during study hours to make the most of your time.",
    },
    {
      icon: <GitBranch className="w-6 h-6 text-primaryColor" />,
      title: "Alternative learning formats",
      desc: "Alternative learning formats provide flexible ways to gain knowledge beyond traditional classroom methods. These include online courses, interactive videos, group discussions, and hands-on activities.",
    },
    {
      icon: <MessageCircle className="w-6 h-6 text-primaryColor" />,
      title: "Mentors with over 5 years of experience",
      desc: "Our mentors have over five years of professional experience in their respective fields. They bring real-world knowledge, practical insights.",
    },
    {
      icon: <GraduationCap className="w-6 h-6 text-primaryColor" />,
      title: "Follow the Training Program",
      desc: "Following the training program helps you stay on track and achieve your learning goals effectively. It provides a clear roadmap for developing skills step by step",
    },
  ];
  return (
    <div className="max-w-full lg:-mx-8 ">
      {" "}
      <section className=" bg-white -pt-1 xl:py-14 px-6 md:-px-16 lg:px-20  border-t border-gray-100 -translate-y-6  ">
        <div className="  mx-auto text-left">
          <div className="flex justify-between">
            <h2 className="text-4xl  font-bold  md:text-5xl  text-primaryTextColor leading-tight heading">
              What to Expect from a <br className="hidden md:block" /> Collab
              Course
            </h2>
            <p className="text-gray-500 max-w-2xl  md:ml-auto md:text-right font-roboto sub-heading">
              A Collab Course offers an engaging and interactive learning
              experience designed to combine knowledge with practical
              application.
              <br /> You can expect live sessions, hands-on projects, and
              real-time collaboration with mentors and peers.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mt-10">
            {features.map((item, index) => (
              <div key={index} className="flex flex-col items-start space-y-3">
                <div className="bg-[#1B1B1B] p-3 rounded-lg shadow-md">
                  {item.icon}
                </div>
                <h3 className="font-bold text-lg text-gray-900 heading">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm sub-heading">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Expectation;
